/** 리포트 타입 구분 */
export enum REPORT_TYPE {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CONNECTION = 'CONNECTION',
  EMBEDDED = 'EMBEDDED',
}

/** 시트 타입 구분 - 차트, 대시보드 */
export enum SHEET_TYPE {
  CHART = 'CHART',
  DASHBOARD = 'DASHBOARD',
}

/** 대시보드에 포함되는 오브젝트 타입 구분 */
export enum OBJECT_TYPE {
  CHART = 'CHART',
  CHART_REF = 'CHART_REF',
  TEXT = 'TEXT',
  SHAPE = 'SHAPE', // 도형, 이미지 등
}

export enum UNIT_FORMAT_TYPE {
  AUTO = 'AUTO',
  PEOPLE = 'PEOPLE',
  CASES = 'CASES',
  PERCENT = 'PERCENT',
  KRW = 'KRW',
  KM = 'KM',
  MS = 'MS',
}

export enum NUMBER_SCALE_TYPE {
  AUTO = 'AUTO',
  NONE = 'NONE',
  THOUSANDS = 'THOUSANDS',
  MILLIONS = 'MILLIONS',
  BILLIONS = 'BILLIONS',
  TRILLIONS = 'TRILLIONS',
  CUSTOM = 'CUSTOM',
}

export enum LEGEND_POSITION_TYPE {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TOP_LEFT = 'TOP_LEFT',
  TOP_RIGHT = 'TOP_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
  NONE = 'NONE',
}

export enum SELECTOR_TYPE {
  HORIZONTAL_TILES = 'HORIZONTAL_TILES',
  DROPDOWN = 'DROPDOWN',
  MULTIPLE_DROPDOWN = 'MULTIPLE_DROPDOWN',
  SINGLE_DROPDOWN = 'SINGLE_DROPDOWN',
  VERTICAL_LIST_RADIO = 'VERTICAL_LIST_RADIO',
  VERTICAL_LIST_CHECKBOX = 'VERTICAL_LIST_CHECKBOX',
  SEARCH = 'SEARCH',
  SLIDER = 'SLIDER',
  BETWEEN = 'BETWEEN',
  RELATIVE_DATE = 'RELATIVE_DATE',
}

export enum DATA_LABEL_POSITION_TYPE {
  NONE = 'NONE',
  OUTSIDE = 'OUTSIDE',
  INSIDE = 'INSIDE',
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
  CENTER = 'CENTER',
  ROTATE = 'ROTATE',
  OUTLINE = 'OUTLINE',
  BOTTOM_TOP = 'BOTTOM_TOP',
  CENTER_BOTTOM = 'CENTER_BOTTOM',
}

export enum DATA_LABEL_TITLE_TYPE {
  NONE = 'NONE',
  CUSTOM = 'CUSTOM',
  SERIES = 'SERIES',
}

/** 집계 함수를 구분하는 타입 */
export enum AGGREGATION_TYPE {
  SUM = 'SUM',
  AVG = 'AVG',
  COUNT = 'COUNT',
  MAX = 'MAX',
  MIN = 'MIN',
}

export enum OPERATOR_TYPE {
  EQ = 'EQ',
  NE = 'NE',
  GT = 'GT',
  GTE = 'GTE',
  LT = 'LT',
  LTE = 'LTE',
}

export enum SLICER_OPERATOR_TYPE {
  EQUALS = 'EQUALS',
}

export enum LOGICAL_OPERATOR_TYPE {
  AND = 'AND',
  OR = 'OR',
}

export enum CELL_MERGE_TYPE {
  OFF = 'OFF',
  SAME_VALUE = 'SAME_VALUE',
}

export enum TABLE_STYLE_APPLY_TYPE {
  ALL = 'ALL',
  HEADER = 'HEADER',
  BODY = 'BODY',
}

/** 도형 타입 구분 */
export enum SHAPE_TYPE {
  SQUARE = 'SQUARE',
  ELLIPSE = 'ELLIPSE',
  POLYGON = 'POLYGON',
  LINE = 'LINE',
}

export enum STROKE_TYPE {
  NONE = 'NONE',
  SOLID = 'SOLID',
  DASHED = 'DASHED',
  DOTTED = 'DOTTED',
}

export enum LINE_TYPE {
  CURVED = 'CURVED',
  STRAIGHT = 'STRAIGHT',
}

export enum RADAR_SHAPE_TYPE {
  CIRCLE = 'CIRCLE',
  POLYGON = 'POLYGON',
}

export enum SYMBOL_TYPE {
  CIRCLE = 'CIRCLE',
  ROUND_RECT = 'ROUND_RECT',
  TRIANGLE = 'TRIANGLE',
  DIAMOND = 'DIAMOND',
  PIN = 'PIN',
  ARROW = 'ARROW',
}

/** background option 관련 타입 */
export enum BACKGROUND_OPTION_TYPE {
  SOLID = 'SOLID',
  GRADIENT = 'GRADIENT',
  IMAGE = 'IMAGE',
}

export enum IMAGE_FILL_TYPE {
  FILL = 'FILL',
  FIT = 'FIT',
  COVER = 'COVER',
}

export enum POINT_HEAD_TYPE {
  NONE = 'NONE',
  LINE_ARROW = 'LINE_ARROW',
  TRIANGLE_ARROW = 'TRIANGLE_ARROW',
  CIRCLE_ARROW = 'CIRCLE_ARROW',
  SQUARE_ARROW = 'SQUARE_ARROW',
}

export enum TEXT_VERTICAL_ALIGN_TYPE {
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
}

export enum ALIGN_TYPE {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
  TOP = 'TOP',
  MIDDLE = 'MIDDLE',
  BOTTOM = 'BOTTOM',
  HORIZONTAL_SPACING = 'HORIZONTAL_SPACING',
  VERTICAL_SPACING = 'VERTICAL_SPACING',
}

export enum ORIENTATION_TYPE {
  VERTICAL = 'VERTICAL',
  HORIZONTAL = 'HORIZONTAL',
}

export enum LEGEND_MARKER_TYPE {
  CIRCLE = 'CIRCLE',
  SQUARE = 'SQUARE',
  LINE = 'LINE',
}

export enum DRILL_THROUGH_TYPE {
  PAGE = 'PAGE',
  BACK = 'BACK',
  FORWARD = 'FORWARD',
}

export enum RELATIVE_DATE_TYPE {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  THIS_MONTH = 'THIS_MONTH',
  LAST_MONTH = 'LAST_MONTH',
}
